import { render, staticRenderFns } from "./CommunityCitySanjaeDetail.vue?vue&type=template&id=063b1f65&scoped=true"
import script from "./CommunityCitySanjaeDetail.vue?vue&type=script&lang=js"
export * from "./CommunityCitySanjaeDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityCitySanjaeDetail.vue?vue&type=style&index=0&id=063b1f65&prod&scoped=true&lang=css"
import style1 from "./CommunityCitySanjaeDetail.vue?vue&type=style&index=1&id=063b1f65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b1f65",
  null
  
)

export default component.exports